import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getCheckPreview = (axios: IAxiosInstance) => {
  return async (params: ISchema["#/definitions/IGetCheckPreviewRequest"]) => {
    const { checkIDs, companyID, payrollRunID } = params;
    const definedCheckIDs = (checkIDs ?? []).filter(
      (id): id is string => typeof id === "string" && id.length > 0
    );

    const queryParams: Record<string, string | string[] | undefined> = {
      companyID,
    };
    if (payrollRunID) {
      queryParams.payrollRunID = payrollRunID;
    } else {
      queryParams.checkIDs = definedCheckIDs;
    }

    const response = await axios.noRetry.get(`/api/getCheckPreview`, {
      params: queryParams,
    });
    const resData = response.data;

    if (resData.success) {
      return resData;
    }

    throw new Error("Something went wrong");
  };
};
